<spk-card title="Admin Links" divider="true">
  <ul class="nav navbar-nav item">
    <li>
      <a [routerLink]="['/countries']" routerLinkActive="active">Countries</a>
    </li>
  </ul>
</spk-card>
